import {useGetBackendVersionQuery} from "@common/services/src/services";

interface AppVersions {
    front: string;
    back: string | null;
    loading: boolean;
}

export const useAppVersions = (frontVersion: string): AppVersions => {
    const { data, isLoading } = useGetBackendVersionQuery();

    return {
        front: frontVersion,
        back: data?.version ?? 'N/A',
        loading: isLoading,
    };
};